import React, { ReactNode, useEffect, useState } from "react";
import { UserInfo } from "../../../apps/reader/framework/api/features/user/types";
import { ApiActionResponse } from "../../../apps/reader/framework/api/core/action-types";
import useSessionChecks from "./useSessionChecks";
import useMonitoringAttribute from "../../ui/useMonitoringAttribute";
import RedirectToLogin from "../../ui/RedirectToLogin";

/**
 * Requires mosaic to be loaded
 * @param children
 * @param render
 * @constructor
 */
export const MosaicSessionGate: React.FC<{
  render?: (userInfo: UserInfo) => ReactNode;
}> = ({ children, render }) => {
  const [response, setResponse] = useState<ApiActionResponse<UserInfo> | null>(
    null
  );

  useMonitoringAttribute(
    "userId",
    response?.ok ? response.data.identifier : undefined
  );

  const {
    needsEmailVerification,
    needsSSOCompletion,
    needsTOSCompletion,
  } = useSessionChecks(response?.data || {});

  useEffect(() => {
    window.Jigsaw.User.getInfo().then((response) => {
      setResponse(response);
    });
  }, []);

  if (!response) {
    return null;
  }

  if (
    !response.ok ||
    needsEmailVerification ||
    needsSSOCompletion ||
    needsTOSCompletion
  ) {
    return <RedirectToLogin finalizeLogout={false} />;
  }

  if (render) {
    return <>{render(response.data)}</>;
  }
  return <>{children}</>;
};

export default MosaicSessionGate;
